import auth from "./auth.json";
import characters from "./characters.json";
import common from "./common.json";
import dungeons from "./dungeons.json";
import gameSettings from "./gameSettings.json";
import live from "./live.json";
import settings from "./settings.json";
import tuning from "./tuning.json";
import validation from "./validation.json";
import weapons from "./weapons.json";
import workshop from "./workshop.json";

export const en = { common, auth, workshop, characters, weapons, tuning, live, gameSettings, settings, dungeons, validation };
